import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Registers the app-shell service worker so Chrome/Android offers "Install
// app" (own icon, standalone window) and attendees get a faster reload on a
// spotty conference-room Wi-Fi. Safe to skip on browsers without support
// (older Safari) — the site just works as a normal web page there.
//
// Production builds only. The worker serves static files cache-first, which is
// right for Vite's content-hashed production filenames but wrong for the dev
// server, whose module URLs never change: there it would keep serving old code
// after every edit.
if ("serviceWorker" in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("Service worker registration failed (non-fatal):", err);
      });
    });
  } else {
    // Clean up a worker an earlier dev session may have installed.
    void navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => void r.unregister()));
  }
}
